module.exports = __webpack_public_path__ + "media/images/athletes/3275-45b969721b91a2e0e609ea1fe9400cd3.png";